import { render, staticRenderFns } from "./bsDistToRegCen.vue?vue&type=template&id=90e2ebea&scoped=true&"
import script from "./bsDistToRegCen.vue?vue&type=script&lang=js&"
export * from "./bsDistToRegCen.vue?vue&type=script&lang=js&"
import style0 from "./bsDistToRegCen.vue?vue&type=style&index=0&id=90e2ebea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e2ebea",
  null
  
)

export default component.exports